export default __webpack_public_path__ + "60b10b2308a61cb565bd0898ad07327b.svg";